/**
 * Time Helper Functions
 * Utilities for formatting and handling time inputs in schedules
 */

/**
 * Smart time input formatting - auto adds ":" and formats properly
 * @param {string} value - Raw input value
 * @returns {string} Formatted time string (e.g., "09:00")
 */
export const formatTimeInput = (value) => {
  const nums = value.replace(/\D/g, '').slice(0, 4); // max 4 digits
  
  if (nums.length === 0) return '';
  if (nums.length === 1) {
    // Single digit > 2 means it's the hour (e.g., 9 → 09:)
    return parseInt(nums) > 2 ? `0${nums}:` : nums;
  }
  if (nums.length === 2) return `${nums}:`;
  if (nums.length === 3) return `${nums.slice(0,2)}:${nums.slice(2)}`;
  return `${nums.slice(0,2)}:${nums.slice(2,4)}`;
};

/**
 * Determine shift type based on start time
 * @param {string} startTime - Start time in "HH:MM" format
 * @returns {'morning' | 'evening'} Shift type
 */
export const determineShiftType = (startTime) => {
  const [hours] = startTime.split(':').map(Number);
  if (hours >= 5 && hours < 15) {
    return 'morning';
  } else {
    return 'evening';
  }
};

/**
 * Format shift for display
 * @param {Object|null} shift - Shift object with start_time and end_time
 * @returns {string} Formatted shift display string
 */
export const formatShiftDisplay = (shift) => {
  if (!shift) return '-';
  return `${shift.start_time}-${shift.end_time}`;
};

/**
 * Calculate hours between two time strings
 * @param {string} startTime - Start time in "HH:MM" format
 * @param {string} endTime - End time in "HH:MM" format
 * @returns {number} Hours (handles overnight shifts)
 */
export const calculateHours = (startTime, endTime) => {
  const startParts = startTime.split(':');
  const endParts = endTime.split(':');
  const startMinutes = parseInt(startParts[0]) * 60 + parseInt(startParts[1]);
  let endMinutes = parseInt(endParts[0]) * 60 + parseInt(endParts[1]);
  
  // Handle overnight shifts
  if (endMinutes <= startMinutes) {
    endMinutes += 24 * 60;
  }
  
  return (endMinutes - startMinutes) / 60;
};

